module.exports = __webpack_public_path__ + "img/changlong_rm.08e90417.png";